import React from 'react';

const ImageReference = () => {
  const images = [
    {
      id: 1,
      src: "https://images.pexels.com/photos/164743/pexels-photo-164743.jpeg?auto=compress&cs=tinysrgb&w=800",
      usage: ["PianoGallery - YAMAHA", "PianoNumeriquesNeufs - YAMAHA"]
    },
    {
      id: 2,
      src: "/imageskawai.jpeg",
      usage: ["PianoGallery - KAWAI", "PianoNumeriquesNeufs - KAWAI", "PianoNumeriquesOccasion - KAWAI", "PianoAcoustiquesOccasion - SAUTER", "ServicesPage - Réparation"]
    },
    {
      id: 3,
      src: "/adagio.jpg",
      usage: ["PianoGallery - ADAGIO", "PianoNumeriquesNeufs - ADAGIO", "PianoNumeriquesOccasion - ADAGIO", "PianoAcoustiquesOccasion - ADAGIO", "PianoQueueDroitNeufs - ADAGIO"]
    },
    {
      id: 4,
      src: "/image1.jpg",
      usage: ["ServicesPage - Vente", "ServicesPage - Section détails"]
    },
    {
      id: 5,
      src: "/image2.jpg",
      usage: ["ServicesPage - Expertise", "HistoirePage - Histoire familiale"]
    },
    {
      id: 6,
      src: "/image8.jpg",
      usage: ["ServicesPage - Transport"]
    },
    {
      id: 7,
      src: "/image10.jpg",
      usage: ["PianoQueueDroitNeufs - KAWAI"]
    },
    {
      id: 8,
      src: "/image11.jpg",
      usage: ["PianoNumeriquesOccasion - YAMAHA", "PianoAcoustiquesOccasion - KAWAI"]
    },
    {
      id: 9,
      src: "/image13.jpg",
      usage: ["PianoQueueDroitNeufs - YAMAHA"]
    },
    {
      id: 10,
      src: "/pexels-pixabay-164743.jpg",
      usage: ["HistoirePage - Jean-Claude Buchta"]
    },
    {
      id: 11,
      src: "https://images.pexels.com/photos/164743/pexels-photo-164743.jpeg?auto=compress&cs=tinysrgb&w=1200",
      usage: ["PianoGallery - Pianos Numériques", "Services - Accordage"]
    },
    {
      id: 12,
      src: "https://images.pexels.com/photos/5070054/pexels-photo-5070054.jpeg?auto=compress&cs=tinysrgb&w=1200",
      usage: ["PianoGallery - Pianos Acoustiques"]
    },
    {
      id: 13,
      src: "https://images.pexels.com/photos/1246437/pexels-photo-1246437.jpeg",
      usage: ["Locations - Mulhouse", "LocationsPage - Mulhouse"]
    },
    {
      id: 14,
      src: "https://images.pexels.com/photos/164743/pexels-photo-164743.jpeg",
      usage: ["Locations - Gérardmer", "LocationsPage - Gérardmer"]
    },
    {
      id: 15,
      src: "https://images.pexels.com/photos/1407354/pexels-photo-1407354.jpeg",
      usage: ["PianoAcoustiquesOccasion - Section détails"]
    }
  ];

  return (
    <div className="min-h-screen pt-20 bg-black">
      <div className="container mx-auto px-6 py-12">
        <h1 className="text-4xl font-light text-white mb-8 text-center">
          Référence des <span className="text-yellow-400">Images du Site</span>
        </h1>

        <div className="glass-card rounded-2xl p-8 mb-8">
          <p className="text-white/70 text-center">
            Cette page liste toutes les images utilisées sur le site avec leur numéro de référence.
            <br />
            Pour changer une image, dites-moi simplement : "Change l'image #X par [nouvelle image]"
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {images.map((img) => (
            <div key={img.id} className="glass-card rounded-2xl overflow-hidden">
              <div className="relative h-48 bg-gray-900">
                <img
                  src={img.src}
                  alt={`Image ${img.id}`}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    (e.target as HTMLImageElement).src = 'https://images.pexels.com/photos/164743/pexels-photo-164743.jpeg?auto=compress&cs=tinysrgb&w=400';
                  }}
                />
                <div className="absolute top-4 left-4 bg-yellow-400 text-black font-bold text-xl px-4 py-2 rounded-full">
                  #{img.id}
                </div>
              </div>

              <div className="p-4">
                <h3 className="text-white font-semibold mb-2">Image #{img.id}</h3>
                <p className="text-white/50 text-xs mb-3 break-all">{img.src}</p>
                <div className="space-y-1">
                  <p className="text-white/70 text-sm font-semibold mb-1">Utilisée dans :</p>
                  {img.usage.map((use, idx) => (
                    <p key={idx} className="text-white/60 text-xs pl-2">• {use}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImageReference;
